<template>
    <div>
       <!-- :label="field.label" -->
        <b-form-group
         
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired,
            }"
            ><label
                :class="{
                    'urdu-label': urduLabel,
                }"
                >{{ field.label }}</label
            >
            <!-- <label for=""
                >{{ field.label }}<br v-if="field.breakLine" /><span
                    v-if="field.urduLabel"
                    class="urdu-label"
                >
                    ({{ field.urduLabel }})</span
                ></label
            > -->
            <!-- <masked-input
                    placeholder="Enter ID Document Number"
                    mask="AA 11 AAAA ################"
                    v-model="model"
                    @input="rawVal = arguments[1]"
                    class="form-control"
                /> -->
            <the-mask
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                    max: 24,
                    min: 24,
                }"
                class="form-control"
                mask="AA ## AAAA XXXXXXXXXXXXXXXX"
                :data-vv-name="field.label"
                placeholder="Enter Account Number/IBAN (e.g. PK 00 AAAA 000000AA234567AA)"
                :tokens="tokens"
                :class="{
                        'is-invalid': errors.has(field.label),
                    }"
            >
            </the-mask>
        </b-form-group>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
// import vueMask from 'vue-jquery-mask'
import { TheMask } from 'vue-the-mask'
// import MaskedInput from 'vue-masked-input'
export default {
    /*
  |--------------------------------------------------------------------------
  | Component > inject
  |--------------------------------------------------------------------------
  */
    inject: {
        $validator: '$validator',
    }, // End of Component > inject
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {
        // MaskedInput,
        // vueMask
        TheMask,
    }, // End of Component > components
    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        field: {
            type: Object,
            required: true,
        },
    }, // End of Component > props
    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {
            value: '',
            isDisable: false,
            rawVal: '',
            tokens: {
                '#': { pattern: /\d/ },
                A: {
                    pattern: /[a-zA-Z]/,
                    transform: (v) => v.toLocaleUpperCase(),
                },
                X: {
                    pattern: /[0-9]/,
                    transform: (v) => v.toLocaleUpperCase(),
                },
                // translation: {'S': {pattern: /[a-z]/}, 'A': {pattern: /[A-Za-z0-9]/},}
            },
        }
    }, // End of Component > data
    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['loading']),
        urduLabel(){
            if(this.$store.state.registration.form.languageOption == 'urd'){
                return true
            } else {
                return false
            }
        },
        model: {
            /**
             * Getter to get value for computed property
             * using props from parent componennt
             *
             * @return {mix}
             */
            get: function () {
                if (this.field.isLocked) {
                    return this.$store.getters.getField(this.field.key)
                } else {
                    let customInfo = this.$store.getters.getField(`customInfo`)
                    return customInfo[this.field._id]
                        ? customInfo[this.field._id].value
                        : null
                }
            }, // End of get() method
            /**
             * Setter to set value for computed property
             * notifying the parent component
             *
             * @return {void}
             */
            set: function (newValue) {
                this.value = newValue
                if (this.field.isLocked) {
                    this.$store.commit('updateField', {
                        key: this.field.key,
                        value: newValue,
                    })
                } else {
                    this.$store.commit('updateField', {
                        key: `customInfo.${this.field._id}`,
                        value: {
                            title: this.field.label,
                            type: this.field.type,
                            value: newValue,
                        },
                    })
                }
            }, // End of set() method
        },
    }, // End of Component > methods
    /*
    |--------------------------------------------------------------------------
    | Component > Created
    |--------------------------------------------------------------------------
    */
    created() {}, // End Component > Created

    mounted() {}, // End of Component > computed
    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {}, // End of Component > mounted
}
</script>
